import React from "react";
import "./PartnerProgram.css"; // Import the CSS file
import { useNavigate } from "react-router-dom";
const PartnerProgram = () => {
  const navigate = useNavigate(); // Get navigation function

  const handlePartnerClick = () => {
    navigate("/partner-signup"); // Navigate to partner signup page
  };
  return (
    <div className="partner">
      <div className="partner-container">
        <div className="partner-content">
          <h3 className="hero-title">
            Manage Your Event & <br></br>
            <span className="highlight">Short-Term Task With US</span>
          </h3>
          <p className="partner-subtitle">
            Get the extra hands, exactly when you need them.
          </p>

          <div className="partner-buttons">
            <button className="partner-btn" onClick={handlePartnerClick}>
              Become a Partner
            </button>

            <span className="partner-note">
              Enjoy a hassle-free service experience
            </span>

            {/* Uncomment when ready for Google Play button */}
            {/* <button
              className="google-play-btn"
              onClick={() => alert("App coming soon to Google Play!")}
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
              />
            </button> */}
          </div>
        </div>

        {/* Optional: Add phone mockups section */}
        <div className="phone-mockups">
          {/* Add your phone mockup images here */}
          {/* <img src="phone-mockup-1.png" alt="App mockup" className="phone-mockup" />
          <img src="phone-mockup-2.png" alt="App mockup" className="phone-mockup" /> */}
        </div>
      </div>
    </div>
  );
};

export default PartnerProgram;
